<template>
  <div>
    <div class="valueAdder">
      <b-input :disabled="disabled" :state="(required && values.length === 0) ? false : null" v-model="newValue" :placeholder="placeholder" @keydown.native.enter="addValue"></b-input>
      <b-btn class="ml-3 button" variant="light" @click="addValue">{{ buttonText }}</b-btn>
    </div>
    <div class="stringList mt-2" v-if="values">
      <b-btn class="button valueButton py-1 m-1" size="sm" variant="light-muted" v-for="(val, index) in values" :key="index">
        {{ val }}
        <span class="h6 align-middle pl-2 font-weight-bold item-remove" @click="removeValue(index)">
          &times;
        </span>
      </b-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    values: { type: Array, required: true },
    placeholder: { type: String, default: 'Enter value' },
    buttonText: { type: String, default: 'Enter' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      newValue: null
    }
  },
  methods: {
    removeValue (index) {
      this.values.splice(index, 1)
    },
    splitBy(val, char) {
      if(val.indexOf(char) > -1) {
        let vals = val.split(char)
        if(vals.length) {
          for(let en of vals) {
            let e = en.trim()
            if(e) {
              this.values.push(e)
            }
          }

          return true
        }
      }

      return false
    },
    addValue () {
      let v = this.newValue

      if (!v || !v.length) return

      let multi = false
      multi = this.splitBy(v, '\n')
      if(!multi) {
        multi = this.splitBy(v, ' ')
      }
      if(!multi) {
        multi = this.splitBy(v, ',')
      }
      if(!multi) {
        /* only one value */
        this.values.push(v)
      }

      this.newValue = ''
    }
  }
}
</script>

<style scoped>
.valueAdder {
  display: flex;
}
.button {
  font-weight: 500;
}
.valueButton {
}
.valueButton span.item-remove:hover {
  color: var(--danger);
  transition: color 0.25s ease 0s;
}
</style>



// WEBPACK FOOTER //
// src/components/StringListEditor.vue